import React from 'react'
import PropTypes from 'prop-types'
import { Margin } from 'shared/components'

import { AthleteDetailsPanel } from './components/athleteDetailsPanel'

const AthleteViewComponent = ({ athleteId }) => (
  <Margin bottom={2}>
    <AthleteDetailsPanel athleteId={athleteId} />
  </Margin>
)

AthleteViewComponent.propTypes = {
  athleteId: PropTypes.number,
}

export default AthleteViewComponent
